module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_System_16"],"polygon":[{"$":{"points":"16 6 16 2 12 2 12 3 7 3 7 7 4 7 4 6 0 6 0 10 4 10 4 8 7 8 7 12 12 12 12 14 16 14 16 10 12 10 12 11 8 11 8 8 8 7 8 4 12 4 12 6 16 6","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_System_16.svg
// module id = YY7E
// module chunks = 1